export default __webpack_public_path__ + "static/media/_global-link-icon.6bcb3efa.svg";